<template>
  <div class="container">
    <div class="edit-box" v-if="list != null && list.length > 0">
      <div>
        <div @click.stop="allSelectClick" v-if="edit">全选</div>
      </div>
      <div @click.stop="editClick">{{ edit ? "取消" : "编辑" }}</div>
    </div>
    <div class="notice-box" v-if="list != null && list.length > 0">
      <van-list
        v-model="loading"
        :finished="finished"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        @load="getListHandle"
      >
        <div class="notice-item" v-for="(item, index) in list" :key="index">
          <div class="nItem_line" @click="flexibleClick(index)">
            <img
              src="../../../static/images/icon/icon_msg.png"
              class="msgIcon"
              v-if="!edit"
            />
            <div
              class="selectedIcon"
              @click.stop="selectHandle(item.selected, item.RecordId, index)"
              v-else
            >
              <img
                src="../../../static/images/icon/select_on.png"
                v-if="item.selected"
              />
              <img src="../../../static/images/icon/select.png" v-else />
            </div>
            <div class="nItem_title">
              <div :class="item.show ? '' : 'overFlowOne'">
                {{ item.Title }}
              </div>
              <div
                class="iconfont rightIcon"
                :class="item.show ? 'icon-arrow-up' : 'icon-arrow-down'"
              ></div>
            </div>
          </div>
          <div class="nItem_panel" v-if="item.show">
            {{ item.Desc }}
          </div>
        </div>
      </van-list>
    </div>
    <div class="noDataBox" v-else>
      <span class="iconfont icon-kong"></span>
      <div>什么也没有!</div>
    </div>
    <div class="operation-box" v-if="edit && list != null && list.length > 0">
      <div class="clearBtn" @click.stop="deleteAllMsg">一键清空</div>
      <div class="deleteBtn" @click.stop="deleteMsg">
        删除（{{ selectIds.length }}）
      </div>
    </div>
  </div>
</template>
<script>
import {
  memberMessage,
  batchDeleteMemberMessage,
  deleteAllMemberMessage,
} from "@/api/member";
import { List, Toast } from "vant";
export default {
  name: "sysMessage",
  components: {
    "van-list": List,
  },
  data() {
    return {
      edit: false,

      loading: false,
      finished: false,
      total: 0,
      pageIndex: 1,
      error: false,
      list: [],

      all: false,
      selectIds: [],
    };
  },
  methods: {
    //获取动态列表
    getListHandle() {
      var that = this;
      var data = {
        Page: {
          PageSize: 10,
          PageIndex: that.pageIndex,
        },
      };
      memberMessage(data)
        .then((res) => {
          for (var i in res.Data.List) {
            res.Data.List[i].show = false;
            res.Data.List[i].selected = false;
          }
          if (that.pageIndex == 1) {
            that.list = [...res.Data.List];
          } else {
            that.list = [...that.list, ...res.Data.List];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch((err) => {
          that.loading = false;
          that.error = true;
          that.Common.showMsg(err);
        });
    },

    //编辑按钮点击
    editClick() {
      var newlist = this.list;
      newlist.forEach(function (val, index) {
        val.selected = false;
      });
      this.edit = !this.edit;
      this.selectIds = [];
      this.list = newlist;
    },

    //展开、收起点击
    flexibleClick(idx) {
      var newlist = this.list;
      newlist.forEach(function (val, index) {
        if (index == idx) {
          val.show = !val.show;
        }
      });
      this.list = newlist;
    },

    //全选点击
    allSelectClick() {
      var newlist = this.list;
      newlist.forEach(function (val, index) {
        val.selected = !this.all;
      });
      this.all = !this.all;
      this.list = newlist;
      if (this.all) {
        var idlist = [];
        this.list.forEach(function (val, index) {
          idlist.push(val.RecordId);
        });
        this.selectIds = idlist;
      } else {
        this.selectIds = [];
      }
    },

    //操作数据的id
    selectHandle(selected, id, index) {
      var ids = this.selectIds;
      if (selected) {
        for (var i in ids) {
          if (ids[i] == id) {
            ids.splice(i, 1);
          }
        }
        this.all = false;
      } else {
        ids.push(id);
      }
      this.list[index].selected = !selected;
      this.selectIds = ids;
    },

    //批量删除消息
    deleteMsg() {
      var that = this;
      if (that.selectIds.length <= 0) {
        setTimeout(() => {
          Toast("请选择要删除的数据");
        }, 2000);
        return false;
      }
      that.Common.showMsg("确认删除选中数据吗？", function () {
        var data = {
          Ids: that.selectIds,
        };
        batchDeleteMemberMessage(data).then((res) => {
          setTimeout(() => {
            Toast("删除成功");
            setTimeout(() => {
              that.selectIds = [];
              that.pageIndex = 1;
              that.list = [];
              that.getListHandle();
            });
          }, 500);
        }, 0);
      });
    },

    //清空消息
    deleteAllMsg() {
      var that = this;
      that.Common.showMsg("确认清空数据吗？", function () {
        var data = {};
        deleteAllMemberMessage(data).then((res) => {
          setTimeout(() => {
            Toast("清空成功");
            setTimeout(() => {
              that.selectIds = [];
              that.pageIndex = 1;
              that.list = [];
            });
          }, 500);
        }, 0);
      });
    },
  },
  mounted() {
    this.getListHandle();
  },
};
</script>
<style lang="less" scoped>
.container {
  background-color: #f5f5f5;
  .edit-box {
    height: 48px;
    font-size: 14px;
    color: #2268e8;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 17px;
  }
  .notice-box {
    background-color: #ffffff;
    .notice-item {
      color: #333333;
      font-size: 13px;
      border-bottom: 1px solid #dddddd;
      padding: 0 12px;
      .nItem_line {
        padding: 16px 0;
        position: relative;
        .msgIcon {
          width: 25px;
          height: 25px;
          position: absolute;
          top: 13px;
          left: -3px;
        }
        .selectedIcon {
          width: 20px;
          height: 20px;
          position: absolute;
          z-index: 4;
          top: 17px;
          left: 0px;
          img {
            width: 15px;
            height: 15px;
            vertical-align: top;
          }
        }
        .nItem_title {
          display: flex;
          justify-content: space-between;
          div {
            line-height: 18px;
            padding-left: 25px;
          }
          .rightIcon {
            width: 15px;
            height: 15px;
            font-size: 10px;
            color: #999;
          }
        }
      }
      .nItem_panel {
        padding-left: 13px;
        padding-bottom: 15px;
      }
    }
  }

  .operation-box {
    position: fixed;
    z-index: 5;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 50px;
    box-sizing: border-box;
    padding: 0 13px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #efefef;
    font-size: 12px;
    .clearBtn {
      width: 78px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(204, 204, 204, 1);
      border-radius: 2px;
      color: #666666;
      -webkit-border-radius: 2px;
      -moz-border-radius: 2px;
      -ms-border-radius: 2px;
      -o-border-radius: 2px;
    }

    .deleteBtn {
      padding: 0 9px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background: rgba(255, 255, 255, 1);
      border-radius: 2px;
      background: #eb4e4e;
      color: #ffffff;
      -webkit-border-radius: 2px;
      -moz-border-radius: 2px;
      -ms-border-radius: 2px;
      -o-border-radius: 2px;
    }
  }
}
</style>

